/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import AENavBackToMain from "../components/NavBackToMain";
import AENavBrand from "../components/NavBrand";
import AENavHelp from "../components/NavHelp";
import AENavLanguagePicker from "../components/NavLanguagePicker";
import BSGlyphicon from "react-bootstrap/Glyphicon";
import BSMenuItem from "react-bootstrap/MenuItem";
import BSNav from "react-bootstrap/Nav";
import BSNavbar from "react-bootstrap/Navbar";
import BSNavDropdown from "react-bootstrap/NavDropdown";
import BSNavItem from "react-bootstrap/NavItem";
import {decodeEntities} from "security";
import PropTypes from "prop-types";
import React, {Component} from "react";
import {noWhitespace} from "tempura";

export default class OrganizationAdminApplication extends Component {
  static propTypes = {
    assetsUrl: PropTypes.string.isRequired,
    children: PropTypes.any,
    languages: PropTypes.object.isRequired,
    organization: PropTypes.shape({
      friendlyId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    sessionLanguage: PropTypes.string.isRequired,
    user: PropTypes.object,
  };

  static contextTypes = {
    __: PropTypes.func.isRequired,
  };

  render() {
    const {
      __,
    } = this.context;

    const {
      assetsUrl,
      brand,
      features,
      languages,
      organization,
      sessionLanguage,
      tenantId,
      user,
    } = this.props;

    return (
      <div id="organization-admin">
        <BSNavbar fixedTop fluid>
          <BSNavbar.Header>
            <AENavBrand
              assetsUrl={assetsUrl}
              brand={brand}
              tenantId={tenantId}
              admin
            />
            <BSNavbar.Toggle />
          </BSNavbar.Header>
          <BSNavbar.Collapse>
            <BSNav className="navbar-orgName">
              {user.organizations.length > 1 ? (
                <BSNavDropdown
                  id="menu-organization-picker"
                  title={
                    <span className="orgName">
                      {decodeEntities(organization.name)}
                    </span>
                  }
                >
                  {user.organizations.map((
                    {
                      friendlyId,
                      id,
                      name,
                    },
                    index,
                  ) => ((id !== organization.id) ? (
                    <BSMenuItem
                      href={noWhitespace`
                        /${__("routes::selleraccount")}
                        /${friendlyId}
                      `}
                      key={index}
                    >
                      {decodeEntities(name)}
                    </BSMenuItem>
                  ) : null))}
                </BSNavDropdown>
              ) : (
                <BSNavItem
                  href={noWhitespace`
                    /${__("routes::selleraccount")}
                    /${organization.friendlyId}
                  `}
                >
                  <span className="orgName">
                    {decodeEntities(organization.name)}
                  </span>
                </BSNavItem>
              )}
            </BSNav>
            <BSNav pullRight>
              <BSNavItem
                href={noWhitespace`
                  /${__("routes::selleraccount")}
                  /${this.props.organization.friendlyId}
                `}
              >
                <BSGlyphicon glyph="dashboard" />
                {` ${__("menu::sellerDashboard")}`}
              </BSNavItem>
              <AENavLanguagePicker
                languages={languages}
                sessionLanguage={sessionLanguage}
              />
              {features.helpCenter ? <AENavHelp /> : null}
              <AENavBackToMain />
            </BSNav>
          </BSNavbar.Collapse>
        </BSNavbar>

        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../render/customApplications/organizationAdmin.jsx